(function (factory) {
  typeof define === 'function' && define.amd ? define(factory) :
  factory();
})((function () { 'use strict';

  /*
   + Mini-gallery Extention
   +
   + Prevent the height jump without using a fixed height textblock:
   + look at children, find tallest, apply min-height to .mini-gallery__items
   */

  let mini_gallery_height = function() {
    // get all the galleries in the page - sometimes it's more than one
    let mini_galleries = document.querySelectorAll('.mini-gallery');
    if (!mini_galleries) return;
    // for each gallery in the page...
    for (let gallery of mini_galleries) {
      let gallery_wrapper = gallery.querySelector('.mini-gallery__items'),
          gallery_items = gallery.querySelectorAll('.mini-gallery__item'),
          largest_height = 0;
      // look at each child, find the tallest
      for (let item of gallery_items) {
        let my_height = item.offsetHeight;
        if (my_height > largest_height) { largest_height = my_height; }    }
      // and use that to set the min-height
      gallery_wrapper.style.minHeight = largest_height + "px";
    }
  };

  mini_gallery_height();

  window.addEventListener('resize', mini_gallery_height);

}));
